import { FC } from 'react';
import { Star, Calendar, Award } from 'lucide-react';
import { cn } from '../../../../utils/cn';
import type { TherapistProfile } from '../../../../types/therapist-dashboard.types';

export interface StatsDisplayProps {
  profile: TherapistProfile;
}

const formatNumber = (num: number) => {
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}k`;
  }
  return num.toString();
};

export const StatsDisplay: FC<StatsDisplayProps> = ({ profile }) => {
  const stats = [
    {
      icon: Star,
      label: 'Rating',
      value: profile.rating ? profile.rating.toFixed(1) : 'N/A',
      subValue: `${profile.totalReviews} reviews`,
      color: 'text-yellow-500',
    },
    {
      icon: Calendar,
      label: 'Appointments',
      value: formatNumber(profile.totalAppointments),
      subValue: 'total',
      color: 'text-blue-500',
    },
    {
      icon: Award,
      label: 'Completion Rate',
      value: `${profile.completionRate}%`,
      subValue: 'on-time',
      color: 'text-green-500',
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="bg-gray-50 dark:bg-slate-800/50 rounded-lg p-4 text-center border border-gray-200 dark:border-slate-700"
        >
          <stat.icon className={cn('w-5 h-5 mx-auto mb-2', stat.color)} />
          <p className="text-2xl font-bold text-gray-900 dark:text-slate-100">
            {stat.value}
          </p>
          <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">{stat.subValue}</p>
        </div>
      ))}
    </div>
  );
};
